import { useMemo, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { todayISO } from "@/lib/format";

const DOW = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function MonthCalendar({ jobs, selected, onSelect, available = [] }) {
  const [cursor, setCursor] = useState(() => { const d = new Date(); return new Date(d.getFullYear(), d.getMonth(), 1); });
  const today = todayISO();
  const byDay = useMemo(() => jobs.reduce((m, j) => ({ ...m, [j.date]: [...(m[j.date] || []), j] }), {}), [jobs]);
  const cells = useMemo(() => {
    const start = new Date(cursor);
    start.setDate(1 - ((cursor.getDay() + 6) % 7));
    return Array.from({ length: 42 }, (_, i) => { const d = new Date(start); d.setDate(start.getDate() + i); return d; });
  }, [cursor]);
  const move = (n) => setCursor((c) => new Date(c.getFullYear(), c.getMonth() + n, 1));
  return (
    <div className="rounded-2xl border bg-white p-3" data-testid="month-calendar">
      <div className="mb-2 flex items-center justify-between">
        <Button variant="ghost" size="icon" onClick={() => move(-1)} data-testid="calendar-prev"><ChevronLeft className="h-4 w-4" /></Button>
        <p className="font-display font-semibold capitalize" data-testid="calendar-month">{cursor.toLocaleDateString("it-IT", { month: "long", year: "numeric" })}</p>
        <Button variant="ghost" size="icon" onClick={() => move(1)} data-testid="calendar-next"><ChevronRight className="h-4 w-4" /></Button>
      </div>
      <div className="grid grid-cols-7 text-center text-[10px] font-semibold uppercase text-slate-400">{DOW.map((d) => <span key={d} className="py-1">{d}</span>)}</div>
      <div className="grid grid-cols-7 gap-0.5">
        {cells.map((d) => {
          const k = iso(d);
          const list = byDay[k] || [];
          const other = d.getMonth() !== cursor.getMonth();
          return (
            <button key={k} onClick={() => onSelect(k)} data-testid={`calendar-day-${k}`}
              className={`flex h-14 flex-col items-center rounded-lg pt-1 text-sm transition-colors ${selected === k ? "bg-[#61a229] text-white" : k === today ? "bg-[#a2ca6b]/25 font-bold" : available.includes(k) ? "bg-sky-50 ring-1 ring-inset ring-sky-300" : "hover:bg-slate-50"} ${other ? "opacity-40" : ""}`}>
              {d.getDate()}
              <span className="mt-1 flex gap-0.5">
                {list.slice(0, 3).map((j) => <span key={j.id} className={`h-1.5 w-1.5 rounded-full ${selected === k ? "bg-white" : j.status === "completato" ? "bg-slate-400" : "bg-[#61a229]"}`} />)}
              </span>
              {list.length > 3 && <span className="text-[9px]">+{list.length - 3}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
